import React, { createContext, useContext, useState, useCallback } from 'react';

export type StyleType = 'styleA' | 'styleB' | 'styleC' | 'styleD';

interface StyleContextType {
  selectedStyle: StyleType;
  setSelectedStyle: (style: StyleType) => void;
}

const StyleContext = createContext<StyleContextType>({
  selectedStyle: 'styleC',
  setSelectedStyle: () => {},
});

export const useStyleContext = () => useContext(StyleContext);

interface StyleProviderProps {
  children: React.ReactNode;
}

// Synchronously get initial style from localStorage
const getInitialStyle = (): StyleType => {
  try {
    const stored = localStorage.getItem('tod-style');
    if (stored && (stored === 'styleA' || stored === 'styleB' || stored === 'styleC' || stored === 'styleD')) {
      return stored as StyleType;
    }
  } catch (error) {
    console.warn('Failed to load style preference:', error);
  }
  return 'styleC';
};

export const StyleProvider: React.FC<StyleProviderProps> = ({ children }) => {
  const [selectedStyle, setSelectedStyleState] = useState<StyleType>(getInitialStyle);

  const setSelectedStyle = useCallback((style: StyleType) => {
    setSelectedStyleState(style);
    try {
      localStorage.setItem('tod-style', style);
    } catch (error) {
      console.warn('Failed to save style preference:', error);
    }
  }, []);

  return (
    <StyleContext.Provider value={{ selectedStyle, setSelectedStyle }}>
      {children}
    </StyleContext.Provider>
  );
};

export default StyleContext;
